import { render, staticRenderFns } from "./Fillgrid.vue?vue&type=template&id=2b0295ac&scoped=true"
import script from "./Fillgrid.vue?vue&type=script&lang=ts"
export * from "./Fillgrid.vue?vue&type=script&lang=ts"
import style0 from "./Fillgrid.vue?vue&type=style&index=0&id=2b0295ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0295ac",
  null
  
)

export default component.exports